import * as actionTypes from '../actions/ActionTypes';
import CacheMemory from '../helpers/CacheMemory';
import UserAnalytic from '../helpers/UserAnalytic';

const LinkUserToAnalytic = (userProfile) => {
    try {
        if (!userProfile || !userProfile.userId) return;
        const user = (userProfile.parentUser ? userProfile.parentUser : userProfile);
        const { entityId, userId } = user;
        UserAnalytic.setCurrentUser(entityId, userId);
    } catch (e) {

    }
}

export const RestoreState = (initialState) => {
    initialState.userProfile = null;
};

export default function setupReducer(rs) {
    rs[actionTypes.SET_PROFILE] = (prevState, action) => {
        const userProfile = action.payload;
        LinkUserToAnalytic(userProfile);
        return {
            ...prevState,
            userProfile
        }
    };
}
